import React, { useContext } from 'react';
import './style.scss';
import clsx from 'clsx';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { SearchContext } from '../context/SearchContext';

const PopularSearch = () => {
  //context
  const {
    helpers,
    popularSearchTitle,
    popularSearches,
    enablePopularSearches,
    setSearchTerm,
    indexName,
    templateName,
    language,
    pagination,
    hasPagination,
    getSearchSuggestions,
    startSearchCharatersLength,
    setWordsNotFoundError,
    setIsOpen,
    inputSearchRef,
    openInSamePage,
    pageSize,
  } = useContext(SearchContext);
  //const
  const shouldRenderPopularSearches =
    enablePopularSearches?.value && Array.isArray(popularSearches) && popularSearches.length > 0;
  //methods
  const openSearchWithValue = (tag) => {
    setWordsNotFoundError(false);
    setIsOpen(false);
    let keyword = tag?.value;
    setSearchTerm(keyword);

    let pageSizeValue = pageSize?.value || pageSize;
    if (!openInSamePage) {
      helpers({
        getSearchSuggestions,
        indexName,
        templateName,
        language,
        pagination,
        keyword,
        hasPagination,
        pageSize: pageSizeValue + 1,
        startSearchCharatersLength,
      });
    } else {
      helpers({
        getSearchSuggestions,
        indexName,
        templateName,
        language,
        keyword: keyword || inputSearchRef?.current?.value,
        hasPagination: false,
        pageSize: null,
      });
    }
  };
  //return
  return (
    shouldRenderPopularSearches && (
      <div className="popular-search">
        <RichText className={clsx('popularSearchTitle')} field={popularSearchTitle} />

        <div className={clsx('popularSearchTags')}>
          {popularSearches?.map((tag, index) => {
            let popularSearchValue = tag?.fields?.value;
            let text = tag?.fields?.text;
            return (
              <div
                onClick={() => openSearchWithValue(popularSearchValue)}
                key={index}
                className="popular-search-tag flex-inline flex-align-item-center flex-justify-center"
              >
                <RichText field={text} />
              </div>
            );
          })}
        </div>
      </div>
    )
  );
};

export default PopularSearch;
